import { API, axiosInstance } from "lib";

export const listTutorialModule = (data = {}) => {
  return axiosInstance
    .post(API.LIST_TUTORIAL_MODULE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      // throw err;
    });
};